import React from 'react';
import PropTypes from 'prop-types';
//import Icon from './Icon';
import styled from 'styled-components';

const StyledProp = styled.div`
  text-align: left;
  width: 100%;
  display: table;
  height: 60px;
  border-radius: 8px;
  margin-bottom: 4px;
  overflow: hidden;
  > div {
    display: table-cell;
    vertical-align: middle;
    position: relative;
    padding: 0 16px;
    width: 50%;
    &:first-child {
      background-color: #fff;
      text-transform: uppercase;
      z-index: 4;
      text-align: left;
      box-shadow: 0px 0px 10px 0 rgba(51, 51, 51, .10);
      span {
        font-size: 0.825em;
      }
    }
    &:last-child {
      background-color: #F4F4F4;
      z-index: 3;
      text-align: right;
      span {
        font-size: 0.825em;
        color: #666;
      }
    }
  }
`;

export default function PropertyCompared (props) {
  const {data} = props;
  return (
    <StyledProp>
      <div>
        <span>{data.product}</span>
      </div>
      <div>
        <span>{data.value || "N/A"} {!!data.value && !!data.unit && <span>{data.unit}</span>}</span>
      </div>
    </StyledProp>
  )
}

PropertyCompared.propTypes = {
  data: PropTypes.object
};
